import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

//----- store
import { fetchQCardData } from "../../store/qCardCertificates-actions";

import IconCertificate from "../../assets/img/icons/certificate.svg";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import Styles from "./QCardCertificates.module.css";

const QCardCertificates = (props) => {
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.uiData.isLoading[2]);

	const qCardCertificatesData = useSelector(
		(state) => state.qCardCertificatesData
	);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.dashboard.certificates;

	useEffect(() => {
		dispatch(fetchQCardData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		// console.log("qCardCertificatesData", qCardCertificatesData);
	}, [qCardCertificatesData]);

	return (
		<div className={Styles["QCardCertificates"]}>
			<div className="row">
				<div className={`col-xs-12 ${Styles["title"]}`}>
					{props.title}
				</div>
			</div>

			{isLoading && (
				<div style={{ textAlign: "center" }}>
					<LoadingSpinner />
				</div>
			)}
			{!isLoading && (
				<div className={`row ${Styles["row"]}`}>
					<div className="col-xs-6">
						<span className={Styles["counter"]}>
							{qCardCertificatesData.value}
						</span>
					</div>
					<div className="col-xs-6">
						<span className={Styles["icon-container"]}>
							<img
								src={IconCertificate}
								className={Styles["icon"]}
								alt=""
							/>
						</span>
					</div>
				</div>
			)}
		</div>
	);
};

export default QCardCertificates;
